import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Guid } from 'guid-typescript';

import Swal from "sweetalert2";
import { GatewayFacade } from './../../../../../gateway/src/lib/states/+gateway/gateway.facades';
import { AuthFacade } from './../../../../../auth/src/lib/facades/auth.facade';

import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';
import { Router } from '@angular/router';

import {AuthenticationService} from '../../../../../../apps/epims/mrsoftepims/src/app/services/auth.service';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {
  href: string = "";
  registerForm: FormGroup;
  constructor( private fb: FormBuilder, private gatewayFacade: GatewayFacade, private authFade: AuthFacade,
    private gatewayService: GatewayService,private router: Router,public authServ: AuthenticationService, public authService: AuthService,) { }

  ngOnInit() {

    this.initRegisterForm();
    let location =  window.location.href.split('#')[0];

    this.href = location;

    // if(this.authServ.getUser() != null){
    //   this.router.navigate(['/dashboard']);
    // }
  }


     
  initRegisterForm(){
    let id = Guid.create().toString();

    let uin = Math.floor(10000000000000 + Math.random() * 90000000000000);
    let uinString = uin.toString();
    let subscriberId = Math.floor(Math.random() * 1000000000);
    let subscriberMainId = subscriberId.toString();
    let siteGenericNo = Math.floor(Math.random() * 10000000).toString();
    let resetToken = this.generateRandomString(35);
    this.registerForm = this.fb.group({
      Id: [id],
      UserName: [''],
      PhoneNo: ['080'],
      password: [''],
      Email: [''],
      UserType: ['Subscriber'],
      SubscriberName: [''],
      FirstName: [''],
      LastName: [''],
      middleName: [''],
      StaffName: [''],
      logoURL: [''],
      verifyStatus: [''],
      isConfirmed: [''],
      UIN: [uinString],
      newUser: [''],
      spouseName: [''],
      noOfChildren: [0],
      address: [''],
      gender: [''],
      ocupation: [''],
      userRole: [''],
      slogan: [''],
      SubscriberId: [subscriberMainId],
      SiteId: [id],
      siteName: [''],
      siteNumber: [''],
      levelCount: [0],
      canAddSub: [true],
      siteGenericNumber: [siteGenericNo],
      systemAdminStatus: [''],
      resetPasswordToken: [resetToken],
      resetPasswordExpires: ['05/05/1987'],
      parentId: [''],

    })


   
  }

  generateRandomString (length, randomString="") {
    randomString += Math.random().toString(20).substr(2, length);
    if (randomString.length > length) return randomString.slice(0, length);
    return this.generateRandomString(length, randomString);
  };

  onSubmit(){
    this.authService.subject$.next(true);

    this.registerForm.value.StaffName = this.registerForm.value.SubscriberName;
    this.registerForm.value.Email = this.registerForm.value.UserName;
    let newAdd = [];
    console.log("User Identity", this.registerForm.value);
    newAdd.push(this.registerForm.value)
  
  
     
    let mailData = { fromEmail: '', toEmail: this.registerForm.value.Email, subject: 'Manage Account', task:'', responsibility: '',
    pipelinename: '', pipelinerequestdesc: '', period: '', message: '', salutation: '', footer: '', url: ''};
  
    let salute = "Dear " + this.registerForm.value.StaffName + ' ,';
  
    let conformButtonMsg = "";
  
  
    mailData.salutation = salute;
   
    mailData.message = "Click on the link below to change your password";
    
    mailData.footer = '';
   
  
   let linkURL = this.href + '#/auth/manage/' + this.registerForm.value.Id + '/' + this.registerForm.value.resetPasswordToken;
   mailData.url = linkURL;
   
   console.log("Sending mail ", mailData, this.registerForm.value.Id);
  //   this.gatewayService.sendManageAccountMail(mailData).subscribe((data) => {
  
  //  });
  
   this.registerForm.reset;
  
    this.authFade.addNewUser(newAdd);
  }


//   public List<string> ADUsers(string filter) {
//     if (string.IsNullOrEmpty(filter)) throw new ArgumentNullException(nameof(filter));

//     List<string> users = new List<string>();
//     var ds = new DirectorySearcher(
//         new DirectoryEntry("LDAP://abc.in"), //domain to search
//         $"(&(objectClass=user)(anr={filter}))", //search filter
//         new[] { "givenName", "sn" }) //attributes to load
//     {
//         SizeLimit = 25 //change this depending on how many you want to show
//     };

//     using (var results = ds.FindAll()) {
//         foreach (SearchResult result in results) {
//             users.Add($"{result.Properties["givenName"][0]} {result.Properties["sn"][0]}");
//         }
//     }
//     return users;
// }


  

}
